import PointSystemModal from './PointSystemModal';

export default PointSystemModal;

